import "core-js/modules/es6.object.assign";
import { jsx as ___EmotionJSX } from "@emotion/core";

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import React, { forwardRef } from 'react';
import { PopoverArrowRoot as Root } from "./styled";
var PopoverArrow = forwardRef(function (props, ref) {
  return ___EmotionJSX(Root, _extends({}, props, {
    "aria-hidden": true,
    ref: ref
  }), "\u25BC");
});
PopoverArrow.displayName = 'PopoverArrow';
export default PopoverArrow;